const { registerVueComponent } = require("../../vvuejs/vueRegister.mjs");

registerVueComponent('vform17_upload_file:notification', 'FFileUploadNotification', () => import('./components/FFileUploadNotification.vue'))
